import { render } from "./TravelPhotoOrbit.vue?vue&type=template&id=67fc9b1c&scoped=true"
import script from "./TravelPhotoOrbit.vue?vue&type=script&lang=js"
export * from "./TravelPhotoOrbit.vue?vue&type=script&lang=js"

import "./TravelPhotoOrbit.vue?vue&type=style&index=0&id=67fc9b1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67fc9b1c"]])

export default __exports__